const guidRegex =
  /[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/;

export const parseGuid = (str: string) => {
  const match = str.match(guidRegex);

  return match ? match[0] : null;
};

export const truncate = (str: string, length = 10) =>
  str.length > length ? str.slice(0, length) + '...' : str;
